import { Injectable, Inject } from '@angular/core';
import { LoggerService } from './logger.service';
import { NewRelicService } from './new-relic.service';
import { IpAddressService } from './ip-address.service';
import { PARAM_TRANSFORMERS } from '../models';
import { LogLevel } from './logger-config';
import { LoggingEnvironment } from '../logging-environment.provider';
import { MegaBeaconService } from '../logger/mega-beacon.service';
import * as i0 from "@angular/core";
import * as i1 from "./new-relic.service";
import * as i2 from "./ip-address.service";
import * as i3 from "../logger/mega-beacon.service";
/**
 * Logger specifically designed to handle Angular Errors
 * See: https://discuss.newrelic.com/t/how-to-monitor-angular-5-application/53309/2
 * @export
 * @class ErrorHandlerService
 * @extends {LoggerService}
 * @implements {ErrorHandler}
 */
export class ErrorHandlerService extends LoggerService {
    /**
     * Creates an instance of ErrorHandlerService.
     * @param {NewRelicService} newRelicService
     * @param {LoggerParamsTransformer[]>} paramTransformers
     * @memberof ErrorHandlerService
     */
    constructor(newRelicService, paramTransformers, ipService, environment, megaBeaconService) {
        super(newRelicService, paramTransformers, ipService, environment, megaBeaconService);
        this.caller = 'ErrorHandler';
    }
    /**
     * Handles an error
     * When the type is Error, locally log the complete error, so we see stacktrace
     * @param {*} error
     * @memberof ErrorHandlerService
     */
    handleError(error) {
        if (typeof error === 'string') {
            this.error(error);
        }
        else if (error instanceof Error) {
            this.localLog(LogLevel.ERROR, undefined, error);
            this.serverLog(LogLevel.ERROR, error.message, this.updateParams());
        }
        else {
            this.error('ErrorHandler', error);
        }
    }
    static { this.ɵfac = function ErrorHandlerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorHandlerService)(i0.ɵɵinject(i1.NewRelicService), i0.ɵɵinject(PARAM_TRANSFORMERS), i0.ɵɵinject(i2.IpAddressService), i0.ɵɵinject(LoggingEnvironment), i0.ɵɵinject(i3.MegaBeaconService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ErrorHandlerService, factory: ErrorHandlerService.ɵfac }); }
}
//# sourceMappingURL=error-handler.service.js.map